import $ from 'jquery';
import 'slick-slider';

$(document).ready(() => {
	$('.latest-posts__slider').slick({
		arrows: true,
		dots: true,
		slidesToShow: 3,
		autoplay: true,
		responsive: [
			{
				breakpoint: 1439,
				settings: {
					arrows: false,
				}
			},
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					slidesToShow: 1,
				}
			},
		],
	});
});
